module.exports = __webpack_public_path__ + "img/emailsms_gmail.8463f134.jpg";